import React, { useState } from 'react'
import {
  FaBox,
  FaBriefcaseMedical,
  FaCheckDouble,
  FaFemale,
  FaFileInvoiceDollar,
  FaFilePrescription,
  FaFlask,
  FaMale,
  FaPills,
  FaRoute,
  FaTrashAlt,
  FaXRay
} from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  MdAccessTime,
  MdCancel,
  MdEditNote,
  MdEditSquare,
  MdNoteAdd,
  MdOutlineAdd,
  MdOutlineCancel,
  MdOutlineSick
} from 'react-icons/md'

import { Form, Formik } from 'formik'
import ViewSickeLeaveReport from '../../../pages/HIS/patient-profiling/ViewSickeLeaveReport'
import * as Yup from 'yup'

import CustomChip from '../../../shared/CustomChip'
import {
  cancelVisit,
  deleteVisitHistory,
  getVisitsList,
  removeVisitFromState,
  setSelectedVisitData
} from '../../../redux/slices/VisitsSlice'
import {
  setIsGeneralSearch,
  setSelectPatientData
} from '../../../redux/slices/BeneficiarySlice'
import ReusableModal from '../../../shared/ReuseableModal'
import ConfirmationModal from '../../../shared/ConfirmationModal'
import CustomButton from '../../../shared/CustomButton'
import CheckPermission from '../../../hooks/CheckPermission'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import DropdownField from '../../../shared/DropdownField'
import EmrDetails from '../patient-profile/EMRDetails'
import { fetchData } from '../../../helpers/fetchData'
import Prescription from '../patient-profile/Prescription'
import ClinicalOrderReport, {
  getClinicalOrderItems
} from '../patient-profile/ClinicalOrderReport'
import { FaMoneyBill1Wave } from 'react-icons/fa6'
import { formatDate, formatDateTime } from '../../../utils/FormateDateTime'
import ViewItems from './ViewItems'
import { IoTimeOutline } from 'react-icons/io5'
import ExtednVisitTime from './ExtednVisitTime'
import { CalculateAge } from '../../../utils/CalculateAge'
import ActionButton from './ActionButton'
import TrackingContent from './TrackingContent'
import PatientJourneyModal from './PatientJourneyModal'
import { navigateSecurely } from '../../../utils/secureNavigation'
import EditEmrItemsModal from './EditEmrItemsModal'
import VisitCreateActionsMenu from './VisitCreateActionsMenu'
import { isBusiness42Receptionist, isShowDateOfBirth } from '../../../utils/businessLevelAccess'
import { canEditEmr } from '../../../utils/emrAccess'

const VisitDetail = ({
  visitData,
  visitColor,
  getVisitDataPayload,
  slotData,
  visitCategory,
  getOrdersPayload,
  order,
  orderData
}) => {  
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [viewEmrLoading, setViewEmrLoading] = useState(false)
  const [selectedEmrData, setSelectedEmrData] = useState(null)
  const [openViewEmrModal, setOpenViewEmrModal] = useState(false)

  const [openViewPrescriptionModal, setOpenViewPrescriptionModal] =
    useState(false)
  const [openEditEmrItemsModal, setOpenEditEmrItemsModal] = useState(false)
  const [selectedEditEmrItemsData, setSelectedEditEmrItemsData] = useState(null)
  const [clinicalOrderReportType, setClinicalOrderReportType] = useState(null)
  const [viewItems, setViewItems] = useState(false)
  const [viewSickLeave, setViewSickLeave] = useState(false)
  const [viewVisitTrack, setViewVisitTrack] = useState(false)
  const [trackId, setTrackId] = useState(null)
  const [viewJourney, setViewJourney] = useState(false)
  const [openDeleteVisitModal, setOpenDeleteVisitModal] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [extendModal, setExtendModal] = useState(false)
  const [extendedVisit, setExtendedVisit] = useState(null)
  const auth = useSelector(state => state.auth)
  const isDoc = useSelector(
    state => state.auth.user?.role?.name_en == 'Practitioner'
  )
  const [openCancelVisitModal, setOpenCancelVisitModal] = useState(false)
  const isReceptionist = useSelector(
    state => state.auth.user?.role?.name_en == 'Receptionist'
  )
  const isBusiness42ReceptionistUser = isBusiness42Receptionist(auth?.user)
  const isNurse = useSelector(
    state => state.auth.user?.role?.name_en == 'Nurse'
  )
  const isPractitioner = useSelector(
    state => state.auth.user?.role?.name_en == 'Practitioner'
  )
  const isAdmin = useSelector(
    state => state.auth.user?.role?.name_en == 'Admin'
  )
  const { hasPermission } = CheckPermission()
  const { t } = useTranslation()
  const endDateTimeStr =
    moment(visitData?.visit_date).format('YYYY-MM-DD') +
    ' ' +
    slotData?.end_time
  const endTime = moment(endDateTimeStr, 'YYYY-MM-DD HH:mm')
  const currentTime = moment()
  const isPadiItemExits = visitData?.items?.some(data => data?.status == 'Paid')
  const emrCreationCheck = isNurse ? isPadiItemExits : true

  const handlePayBill = () => {
    let date = moment(getVisitDataPayload?.start_date).format('YYYY-MM-DD')
    let start_time = visitData?.start_time
    let end_time = visitData?.end_time
    let day = moment(getVisitDataPayload?.start_date).format('dddd')
    let selectedPractitionerId = getVisitDataPayload?.practitioner_id
    navigate('/pay-bill', {
      state: {
        start_time,
        day,
        date,
        selectedPractitionerId,
        isPayBill: true,
        billingVisitData: visitData,
        end_time
      }
    })
  }

  const handleNavigateCreateVisit = () => {
    let payment_status = visitData?.payment_status == 'Paid' ? 'paid' : 'unpaid'
    let date = moment(getVisitDataPayload?.start_date).format('YYYY-MM-DD')
    let start_time = slotData?.time
    let end_time = slotData?.end_time
    let day = moment(getVisitDataPayload?.start_date).format('dddd')
    let selectedPractitionerId = getVisitDataPayload?.practitioner_id
    if (order) {
      navigate('/create-special-visit', {
        state: {
          orderData: orderData,
          getOrdersPayload: getOrdersPayload,
          start_time,
          day,
          date,
          end_time
        }
      })
    } else {
      navigate('/create-visit', {
        state: {
          start_time,
          day,
          date,
          end_time,
          selectedPractitionerId,
          payment_status
        }
      })
    }
  }

  const handleViewEmrDetails = async emrNumber => {
    setViewEmrLoading(true)
    let payload = {
      emr_id: Number(emrNumber),
      visit_id: visitData?.visit_id,
      patient_id: visitData?.patient?.patient_id
    }
    let response = await fetchData('POST', '/v3/emr/getById', payload)
    setViewEmrLoading(false)
    if (response?.data) {
      setOpenViewEmrModal(true)
      setSelectedEmrData(response?.data)
    } else {
      setSelectedEmrData(null)
    }
  }

  const handlePrescriptionDetails = async emrNumber => {
    setViewEmrLoading(true)
    let payload = {
      emr_id: Number(emrNumber),
      visit_id: visitData?.visit_id,
      patient_id: visitData?.patient?.patient_id
    }
    let response = await fetchData('POST', '/v3/emr/getById', payload)
    setViewEmrLoading(false)
    if (response?.data) {
      setOpenViewPrescriptionModal(true)
      setSelectedEmrData(response?.data)
    } else {
      setSelectedEmrData(null)
    }
  }

  const refreshVisitData = async () => {
    const payload = {
      ...getVisitDataPayload,
      start_date: moment(getVisitDataPayload?.start_date).format('YYYY-MM-DD'),
      end_date: moment(getVisitDataPayload?.start_date).format('YYYY-MM-DD')
    }
    await dispatch(getVisitsList(payload))
  }

  const handleEditEmrItems = async emrNumber => {
    setViewEmrLoading(true)
    const payload = {
      emr_id: Number(emrNumber),
      visit_id: visitData?.visit_id,
      patient_id: visitData?.patient?.patient_id
    }
    const response = await fetchData('POST', '/v3/emr/getById', payload)
    setViewEmrLoading(false)
    if (response?.data) {
      dispatch(setSelectPatientData(visitData?.patient))
      dispatch(setSelectedVisitData(visitData))
      setSelectedEditEmrItemsData({
        ...response.data,
        ...payload,
        items: response?.data?.items || []
      })
      setOpenEditEmrItemsModal(true)
    } else {
      setSelectedEditEmrItemsData(null)
    }
  }

  const handleClinicalOrderDetails = async reportType => {
    setViewEmrLoading(true)
    const payload = {
      visit_id: visitData?.visit_id,
      patient_id: visitData?.patient?.patient_id
    }
    const response = await fetchData(
      'POST',
      '/v3/emr/getClinicalOrderItems',
      payload
    )
    setViewEmrLoading(false)
    if (getClinicalOrderItems(response?.data?.items, reportType).length > 0) {
      setSelectedEmrData(response.data)
      setClinicalOrderReportType(reportType)
    } else {
      setSelectedEmrData(null)
    }
  }

  const isEmergencyVisit =
    visitData?.priority?.coding?.[0]?.code?.toLowerCase() === 'em' ||
    visitData?.priority?.coding?.[0]?.display?.toUpperCase() === 'EMERGENCY'
  const isCancelledVisit =
    visitData?.status?.toLowerCase() === 'cancelled' ||
    slotData?.appointment?.status?.toLowerCase() === 'cancelled'
  const hasEncounterNumber =
    Array.isArray(visitData?.encounter_number) &&
    visitData.encounter_number.length > 0
  const cardVisitColor = isCancelledVisit
    ? '!bg-red-200'
    : isEmergencyVisit
      ? '!bg-orange-200'
      : visitColor
  return (
    <div className='flex min-w-0 flex-col lg:flex-row w-full items-stretch min-h-auto relative bg-white overflow-hidden '>
      {visitCategory == visitData?.visit_category ||
        (visitData.visit_category === 'special_patient' &&
          visitCategory === 'out_patient') ? (
        <>
          <div className='min-w-0 flex-1 lg:flex-[1] flex flex-col border-b lg:border-b-0 bg-white'>
            <div
              className={`w-full h-auto min-h-[50px] lg:h-[84px] lg:min-h-[84px] xl:h-[60px] xl:min-h-[60px] flex flex-wrap items-center gap-2 px-3 cursor-pointer py-1 ${cardVisitColor}`}
              onClick={() => {
                let patientData = {
                  ...visitData?.patient,
                  visit_id: visitData?.visit_id
                }
                dispatch(setIsGeneralSearch(false))
                dispatch(setSelectPatientData(patientData))
                dispatch(setSelectedVisitData(visitData))
                navigate('/patient-profile/overview')
              }}
            >
              <span
                className={`flex items-center justify-center w-6 h-6 rounded-full 
                            ${visitData?.patient?.gender === 'female'
                    ? 'bg-rose-100 text-rose-600'
                    : visitData?.patient?.gender === 'male'
                      ? 'bg-sky-100 text-sky-600'
                      : null
                  }`}
              >
                {visitData?.patient?.gender === 'female' ? (
                  <FaFemale size={20} />
                ) : visitData?.patient?.gender === 'male' ? (
                  <FaMale size={20} />
                ) : null}
              </span>
              <span
                className='min-w-0 flex-1 break-words text-[15px] font-bold leading-tight text-gray-700 uppercase'
                title={`${t('MRN')}: ${visitData?.patient?.file_no}${visitData?.patient?.old_file_no
                  ? `, ${t('Old MRN')}: ${visitData?.patient?.old_file_no
                  }`
                  : ''
                  }`}
              >
                {visitData?.patient?.full_name || visitData?.participant} (
                {visitData?.patient?.file_no}
                {visitData?.patient?.old_file_no ? (
                  <span>
                    {' '}
                    / {t('Old MRN')}:{' '}
                    <span className='text-red-500'>
                      {visitData?.patient?.old_file_no}
                    </span>
                  </span>
                ) : (
                  ''
                )}
                )
              </span>
            </div>
            <div className='px-4 py-2 flex-1 flex items-center min-h-[50px] bg-white'>
              <div className='flex flex-wrap items-center gap-3'>
                <span className='text-[13px] font-semibold text-gray-800'>
                  {visitData?.patient?.document_id || '--'}
                </span>

                {visitData?.patient?.dob && (
                  <>
                    <span className='text-gray-300 font-light'>|</span>
                    <span className='text-[13px] font-medium text-gray-600 whitespace-nowrap'>
                      {isShowDateOfBirth(auth?.user) ? visitData?.patient?.dob : CalculateAge(visitData?.patient?.dob)}
                    </span>
                  </>
                )}

                <span className='text-gray-300 font-light'>|</span>
                <div className='flex items-center gap-1.5 text-gray-500'>
                  <MdAccessTime size={16} className='text-gray-400' />
                  <span className='text-[13px] font-medium'>
                    {formatDateTime(visitData?.visit_date)}
                  </span>
                </div>

                {visitData?.nursing_status === 'ready' &&
                  (visitData?.nurse_tracking?.triaged_at ||
                    visitData?.called_at) && (
                    <>
                      <span className='text-gray-300 font-light'>|</span>
                      <div className='flex items-center gap-1.5 text-emerald-600'>
                        <i className='pi pi-check-circle text-[14px]'></i>
                        <span className='text-[13px] font-medium whitespace-nowrap'>
                          {t('Triaged By')}:{' '}
                          {visitData?.nurse_tracking?.triaged_by?.name ||
                            visitData?.called_by?.name}{' '}
                          -{' '}
                          {formatDateTime(
                            visitData?.nurse_tracking?.triaged_at ||
                            visitData?.called_at
                          )}
                        </span>
                      </div>
                    </>
                  )}
                {visitData?.referral && (
                  <>
                    <span className='text-gray-300 font-light'>|</span>
                    <div className='flex items-center gap-1.5 text-purple-600'>
                      <FaRoute size={13} />
                      <span className='text-[13px] font-medium whitespace-nowrap'>
                        {t('Referral')}: {visitData.referral.auth_ref || '--'}
                        {visitData.referral.valid_until && (
                          <>
                            {' - '}
                            {t('Valid Until')}:{' '}
                            {formatDate(visitData.referral.valid_until)}
                          </>
                        )}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className='flex flex-wrap items-center gap-2 px-3 py-2 border-t border-gray-100 mt-auto bg-gray-50/50 h-auto min-h-[45px]'>
              <p className='text-[11px] font-semibold text-gray-700 px-2 py-0.5 bg-gray-100 rounded uppercase'>
                {t(visitData?.visit_payment_type) || t('Cash')}
              </p>
              <div className='h-3 w-[1px] bg-gray-200'></div>
              <p className='text-[11px] font-semibold text-gray-500 uppercase'>
                {t('EP')}: {visitData?.episode_id || '--'}
              </p>
            </div>
          </div>
          <div className='min-w-0 flex-1 flex flex-col bg-white'>
            <div
              className={`w-full ${cardVisitColor} h-auto min-h-[50px] lg:h-[84px] lg:min-h-[84px] xl:h-[60px] xl:min-h-[60px] flex flex-wrap items-center justify-end gap-1.5 px-3 py-1`}
            >
              <div className='flex min-w-0 flex-1 flex-wrap items-center justify-end gap-1.5'>
                <CustomChip
                  chipType='mono-light'
                  showActionIcon={true}
                  label={t('Track')}
                  onClick={() => {
                    setViewItems(true)
                    setSelectedEmrData(visitData)
                  }}
                  className='cursor-pointer whitespace-nowrap transition-all !bg-gray-50 !text-gray-500 !border-gray-200'
                  labelClassName='!text-[12px] !uppercase'
                />
                <CustomChip
                  chipType='mono-light'
                  showActionIcon={true}
                  icon={<FaFlask size={12} />}
                  label={t('lab')}
                  onClick={() => {
                    const url = `/patient-profile/all-reports?patient_id=${visitData?.patient?.patient_id}&file_no=${visitData?.patient?.file_no}&document_id=${visitData?.patient?.document_id}&type=lab`
                    window.open(url, '_blank')
                  }}
                  className={`cursor-pointer whitespace-nowrap transition-all !px-2 !bg-gray-50 !text-gray-500 !border-gray-200 ${visitData?.lab_order_status?.toLowerCase().trim() ===
                    'approved'
                    ? '!bg-green-500 !text-white !border-green-500'
                    : ['rejected', 'cancelled'].includes(
                      visitData?.lab_order_status?.toLowerCase().trim()
                    )
                      ? '!bg-red-500 !text-white !border-red-500'
                      : [
                        'inprogress',
                        'sample_collected',
                        'samplecollected',
                        'received',
                        'in_progress',
                        'in-progress'
                      ].includes(
                        visitData?.lab_order_status?.toLowerCase().trim()
                      )
                        ? '!bg-sky-100 !text-sky-600 !border-sky-200'
                        : ''
                    }`}
                  labelClassName={`!text-[12px] !uppercase ${['approved', 'rejected', 'cancelled'].includes(
                    visitData?.lab_order_status?.toLowerCase().trim()
                  )
                    ? '!text-white'
                    : [
                      'inprogress',
                      'sample_collected',
                      'samplecollected',
                      'received',
                      'in_progress',
                      'in-progress'
                    ].includes(
                      visitData?.lab_order_status?.toLowerCase().trim()
                    )
                      ? '!text-sky-600'
                      : ''
                    }`}
                  actionIconClassName={
                    ['approved', 'rejected', 'cancelled'].includes(
                      visitData?.lab_order_status?.toLowerCase().trim()
                    )
                      ? '!text-white'
                      : [
                        'inprogress',
                        'sample_collected',
                        'samplecollected',
                        'received',
                        'in_progress',
                        'in-progress'
                      ].includes(
                        visitData?.lab_order_status?.toLowerCase().trim()
                      )
                        ? '!text-sky-600'
                        : ''
                  }
                />
                <CustomChip
                  chipType='mono-light'
                  showActionIcon={true}
                  icon={<FaXRay size={12} />}
                  label={t('imaging')}
                  onClick={() => {
                    const url = `/patient-profile/all-reports?patient_id=${visitData?.patient?.patient_id}&file_no=${visitData?.patient?.file_no}&document_id=${visitData?.patient?.document_id}&type=imaging`
                    window.open(url, '_blank')
                  }}
                  className={`cursor-pointer whitespace-nowrap transition-all !px-2 !bg-gray-50 !text-gray-500 !border-gray-200 ${['completed', 'approved'].includes(
                    visitData?.radiology_order_status?.toLowerCase().trim()
                  )
                    ? '!bg-green-500 !text-white !border-green-500'
                    : visitData?.radiology_order_status
                      ?.toLowerCase()
                      .trim() === 'cancelled'
                      ? '!bg-red-500 !text-white !border-red-500'
                      : [
                        'received',
                        'inprogress',
                        'in_progress',
                        'in-progress'
                      ].includes(
                        visitData?.radiology_order_status
                          ?.toLowerCase()
                          .trim()
                      )
                        ? '!bg-sky-100 !text-sky-600 !border-sky-200'
                        : ''
                    }`}
                  labelClassName={`!text-[12px] !uppercase ${['completed', 'approved', 'cancelled'].includes(
                    visitData?.radiology_order_status?.toLowerCase().trim()
                  )
                    ? '!text-white'
                    : [
                      'received',
                      'inprogress',
                      'in_progress',
                      'in-progress'
                    ].includes(
                      visitData?.radiology_order_status
                        ?.toLowerCase()
                        .trim()
                    )
                      ? '!text-sky-600'
                      : ''
                    }`}
                  actionIconClassName={
                    ['completed', 'approved', 'cancelled'].includes(
                      visitData?.radiology_order_status?.toLowerCase().trim()
                    )
                      ? '!text-white'
                      : [
                        'received',
                        'inprogress',
                        'in_progress',
                        'in-progress'
                      ].includes(
                        visitData?.radiology_order_status
                          ?.toLowerCase()
                          .trim()
                      )
                        ? '!text-sky-600'
                        : ''
                  }
                />
                <CustomChip
                  chipType='mono-light'
                  showActionIcon={true}
                  label={t('History')}
                  onClick={() => {
                    setViewVisitTrack(true)
                    setTrackId(visitData?.visit_id)
                  }}
                  className='cursor-pointer whitespace-nowrap transition-all !px-2 !bg-gray-50 !text-gray-500 !border-gray-200'
                  labelClassName='!text-[12px] !uppercase'
                />
                <CustomChip
                  chipType='mono-light'
                  showActionIcon={true}
                  label={t('Journey')}
                  onClick={() => setViewJourney(true)}
                  className='cursor-pointer whitespace-nowrap transition-all !bg-primary/5 !text-primary !border-primary/20'
                  labelClassName='!text-[12px] !uppercase'
                  title={t('Patient Journey Timeline')}
                />
              </div>

              <div className='flex items-center gap-2 flex-shrink-0'>
                <VisitCreateActionsMenu
                  visitData={visitData}
                  onEditEmrItems={handleEditEmrItems}
                />
                {/* {visitData?.status === "Cancelled" ? (
                  <CustomChip
                    chipType="soft-danger"
                    label={t("Cancelled")}
                    className="whitespace-nowrap transition-all"
                    labelClassName="!text-[12px] !uppercase"
                  />
                ) : ( */}
                {visitData?.status !== 'Cancelled' &&
                  !visitData?.emr_numbers?.length &&
                  !isBusiness42ReceptionistUser &&
                  hasPermission('visit', 'update') && (
                    <ActionButton
                      variant='danger'
                      icon={<MdCancel />}
                      onClick={() => setOpenCancelVisitModal(true)}
                      title={t('CancelVisit')}
                    />
                  )}
                {/* {!isReceptionist && isAdmin && hasPermission("visit", "delete") && visitData?.emr_numbers?.length > 0 && (
                  <ActionButton
                    variant="danger"
                    sizeChange={false}
                    icon={<FaTrashAlt size={18} />}
                    onClick={() => setOpenDeleteVisitModal(true)}
                    title={t("Delete Patient History")}
                  />
                )} */}
              </div>
            </div>

            <div className='flex flex-wrap items-center justify-start lg:justify-end px-3 py-2 gap-2 flex-1 h-auto'>
              <CustomChip
                chipType='mono-outline'
                showActionIcon={true}
                label={t('medical_summary')}
                onClick={() => {
                  let patientData = {
                    ...visitData?.patient,
                    visit_id: visitData?.visit_id
                  }
                  dispatch(setIsGeneralSearch(false))
                  dispatch(setSelectPatientData(patientData))
                  dispatch(setSelectedVisitData(visitData))
                  navigate('/patient-profile/emr')
                }}
                className='cursor-pointer whitespace-nowrap transition-all !bg-gray-50 !text-gray-500 !border-gray-200'
                labelClassName='!text-[12px] !uppercase'
              />

              <CustomChip
                chipType='mono-outline'
                label={t(visitData?.priority?.coding?.[0]?.display || 'NORMAL')}
                className={`whitespace-nowrap transition-all ${isEmergencyVisit
                  ? '!bg-orange-200 !text-orange-600 !border-orange-500'
                  : '!bg-gray-50 !text-gray-500 !border-gray-200'
                  }`}
                labelClassName='!text-[12px] !uppercase'
              />

              {visitData?.is_temporary_followup && (
                <CustomChip
                  chipType='mono-light'
                  label={t('is_temporary_followup')}
                  className='whitespace-nowrap transition-all !bg-purple-100 !text-purple-600 !border-purple-500'
                  labelClassName='!text-[12px] !uppercase'
                />
              )}

              {visitData?.visit_category === 'special_patient' && (
                <CustomChip
                  chipType='mono-light'
                  label={t('SPECIAL PATIENT')}
                  className='whitespace-nowrap transition-all !bg-yellow-100 !text-yellow-600 !border-yellow-500'
                  labelClassName='!text-[12px] !uppercase'
                />
              )}
              <CustomChip
                chipType='mono-light'
                label={t(visitData?.episode_type)}
                className={`whitespace-nowrap transition-all ${['first visit', 'special visit'].includes(
                  visitData?.episode_type?.toLowerCase()
                )
                  ? '!bg-blue/10 !text-blue !border-blue'
                  : visitData?.episode_type?.toLowerCase() === 'follow up'
                    ? '!bg-yellow-100 !text-yellow-600 !border-yellow-500'
                    : '!bg-gray-50 !text-gray-500 !border-gray-200'
                  }`}
                labelClassName='!text-[12px] !uppercase'
              />
              {hasEncounterNumber && (
                <CustomChip
                  chipType='mono-light'
                  label={t('Admitted')}
                  className='whitespace-nowrap transition-all !bg-blue/10 !text-blue !border-blue/20'
                  labelClassName='!text-[12px] !font-semibold !uppercase'
                />
              )}
            </div>

            <div className='flex flex-wrap items-center justify-start lg:justify-end gap-1.5 px-3 py-2 border-t border-gray-100 mt-auto bg-gray-50/50 h-auto min-h-[45px]'>
              <div className='flex items-center gap-1.5'>

                {hasPermission('emr', 'get') &&
                  visitData?.emr_numbers?.length > 0 && (
                    <>
                      <ActionButton
                        disabled={viewEmrLoading}
                        loading={viewEmrLoading}
                        icon={<FaFilePrescription />}
                        variant='primary'
                        onClick={() =>
                          !viewEmrLoading &&
                          handleViewEmrDetails(visitData?.emr_numbers?.[0])
                        }
                        title={t('Medical Summary')}
                      />
                      <ActionButton
                        disabled={viewEmrLoading}
                        loading={viewEmrLoading}
                        variant='primary'
                        icon={<FaPills />}
                        onClick={() =>
                          !viewEmrLoading &&
                          handlePrescriptionDetails(visitData?.emr_numbers?.[0])
                        }
                        title={t('Prescription')}
                      />
                      {getClinicalOrderItems(visitData?.items, 'laboratory')
                        .length > 0 && (
                          <ActionButton
                            disabled={viewEmrLoading}
                            loading={viewEmrLoading}
                            variant='primary'
                            icon={<FaFlask />}
                            onClick={() =>
                              !viewEmrLoading &&
                              handleClinicalOrderDetails('laboratory')
                            }
                            title={t('Laboratory Order')}
                          />
                        )}
                      {getClinicalOrderItems(visitData?.items, 'imaging')
                        .length > 0 && (
                          <ActionButton
                            disabled={viewEmrLoading}
                            loading={viewEmrLoading}
                            variant='primary'
                            icon={<FaXRay />}
                            onClick={() =>
                              !viewEmrLoading &&
                              handleClinicalOrderDetails('imaging')
                            }
                            title={t('Radiology / Imaging Order')}
                          />
                        )}
                    </>
                  )}

                {hasPermission('visit', 'create') &&
                  visitData?.status === 'Cancelled' &&
                  endTime.isAfter(currentTime, 'minute') && (
                    <ActionButton
                      variant='primary'
                      icon={<MdOutlineAdd />}
                      onClick={handleNavigateCreateVisit}
                      title={t('New Visit')}
                    />
                  )}

                {Array.isArray(visitData?.reference_invoice_number) &&
                  visitData?.reference_invoice_number?.length > 0 &&
                  isReceptionist && (
                    <div className='relative group'>
                      <DropdownField
                        useFormik={false}
                        placeholder={
                          <div className='flex items-center gap-1'>
                            <FaFileInvoiceDollar
                              size={14}
                              className='text-primary group-hover:text-primary transition-colors'
                            />
                            <span className='text-[10px] font-semibold text-primary uppercase md:block hidden'>
                              {t('Invoices')}
                            </span>
                          </div>
                        }
                        className='!w-auto !h-[24px] md:!h-[28px] !mb-0 visit-card-dropdownfield-simple'
                        options={visitData?.reference_invoice_number?.map(
                          v => ({
                            label: v?.cash_invoice_number,
                            value: v?.invoice_number
                          })
                        )}
                        handleChange={e =>
                          navigate(`/print-invoice/${e.target.value}`, {
                            state: {
                              invoiceNumber: e.target.value,
                              state: {
                                file_no: visitData?.patient?.file_no,
                                document_id: visitData?.patient?.document_id
                                // cash_invoice_number:e?.target?.value
                              }
                            }
                          })
                        }
                        ptOptions={{
                          root: {
                            className:
                              '!h-[24px] md:!h-[28px] !min-h-[24px] md:!min-h-[28px] flex items-center !rounded-[6px] !bg-white !border !border-gray-200 hover:!border-gray-300 transition-all !px-2 '
                          },
                          input: { className: 'hidden' },
                          trigger: {
                            className:
                              '!w-full flex items-center justify-center gap-2'
                          },
                          dropdownicon: {
                            className:
                              '!w-[8px] md:!w-[10px] !h-[8px] md:!h-[10px] !text-gray-400 group-hover:!text-gray-600'
                          },
                          item: {
                            className:
                              'capitalize !outline-none text-[10px] md:text-[11px]'
                          }
                        }}
                      />
                    </div>
                  )}

                {!isReceptionist &&
                  hasPermission('emr', 'update') &&
                  visitData?.emr_numbers?.length > 0 &&
                  isPractitioner &&
                  canEditEmr(visitData, isDoc) &&
                  (emrCreationCheck ||
                    ['Follow Up', 'Follow up'].includes(
                      visitData?.visit_type?.type
                    )) &&
                  visitData?.emr_numbers?.map((d, i) => (
                    <ActionButton
                      key={i}
                      icon={<MdEditNote />}
                      variant='warning'
                      onClick={() => {
                        dispatch(setSelectPatientData(visitData?.patient))
                        dispatch(setSelectedVisitData(visitData))
                        navigateSecurely(
                          navigate,
                          '/patient-profile/edit-emr',
                          { emr_id: d, visitData }
                        )
                      }}
                      title={t('EditEMR')}
                    />
                  ))}

                {!isReceptionist &&
                  !visitData?.emr_numbers?.length &&
                  visitData?.status !== 'Cancelled' &&
                  (emrCreationCheck ||
                    ['Follow Up', 'Follow up'].includes(
                      visitData?.visit_type?.type
                    )) &&
                  hasPermission('emr', 'create') && (
                    <ActionButton
                      icon={<MdNoteAdd />}
                      variant='primary'
                      onClick={() => {
                        dispatch(setSelectPatientData(visitData?.patient))
                        dispatch(setIsGeneralSearch(false))
                        dispatch(setSelectedVisitData(visitData))
                        navigateSecurely(
                          navigate,
                          '/patient-profile/create-emr',
                          { visitData }
                        )
                      }}
                      title={t('CreateEMR')}
                    />
                  )}

                {visitData?.status !== 'Cancelled' &&
                  hasPermission('pay-bill', 'create') && (
                    <ActionButton
                      icon={<FaMoneyBill1Wave />}
                      variant='primary'
                      onClick={handlePayBill}
                      title={t('PayBill')}
                    />
                  )}
                <VisitCreateActionsMenu
                  visitData={visitData}
                  printActions
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className='flex flex-col w-full gap-5 items-center justify-center min-h-[100px] overflow-x-auto relative scrollbar'>
          <p className='text-16-gray'>
            {visitCategory === 'out_patient' ||
              (visitData.visit_category === 'special_patient' &&
                visitCategory === 'out_patient')
              ? t('This slot is Booked for In Patient')
              : t('This slot is Booked for Out Patient')}
          </p>
        </div>
      )}
      {/* Modals */}
      <ReusableModal
        isVisible={extendModal}
        title={t('Extend Visit Time')}
        HeaderIcon={IoTimeOutline}
        position='top'
        onClose={() => {
          setExtendModal(false)
          setExtendedVisit(null)
        }}
      >
        <ExtednVisitTime
          visit={extendedVisit}
          setExtendModal={setExtendModal}
          setExtendedVisit={setExtendedVisit}
          getVisitDataPayload={getVisitDataPayload}
        />
      </ReusableModal>

      <ReusableModal
        isVisible={openCancelVisitModal}
        title={t('CancelVisit')}
        HeaderIcon={MdOutlineCancel}
        position='top'
        onClose={() => {
          setOpenCancelVisitModal(false)
        }}
      >
        <CancelVisitForm
          getVisitDataPayload={getVisitDataPayload}
          setOpenCancelVisitModal={setOpenCancelVisitModal}
          visitData={visitData}
        />
      </ReusableModal>

      <ReusableModal
        position='top'
        isVisible={openViewEmrModal}
        title={t('emr_details')}
        HeaderIcon={FaBriefcaseMedical}
        onClose={() => {
          setOpenViewEmrModal(false)
          setSelectedEmrData(null)
        }}
        className='w-full lg:w-[850px] relative'
      >
        <EmrDetails emrData={selectedEmrData} />
      </ReusableModal>

      <ReusableModal
        position='top'
        isVisible={viewItems}
        title={t('Items')}
        HeaderIcon={FaBox}
        onClose={() => {
          setViewItems(false)
          setSelectedEmrData(null)
        }}
        className='w-full lg:w-[95%] relative'
        messagePaid={true}
      >
        <ViewItems visitData={selectedEmrData} />
      </ReusableModal>

      <ReusableModal
        className='w-full md:w-[800px] lg:w-[1000px] h-[90vh] relative'
        isVisible={viewSickLeave}
        title={t('Sick Leave Report')}
        position='top'
        onClose={() => {
          setViewSickLeave(false)
          setSelectedEmrData(null)
        }}
      >
        <ViewSickeLeaveReport selectedLeaveData={selectedEmrData} />
      </ReusableModal>

      <ReusableModal
        position='top'
        isVisible={openViewPrescriptionModal}
        title={t('Prescription')}
        HeaderIcon={FaBriefcaseMedical}
        onClose={() => {
          setOpenViewPrescriptionModal(false)
          setSelectedEmrData(null)
        }}
        className='w-full lg:w-[850px] relative'
      >
        <Prescription emrData={selectedEmrData} />
      </ReusableModal>

      {openEditEmrItemsModal && selectedEditEmrItemsData && (
        <ReusableModal
          position='top'
          isVisible={openEditEmrItemsModal}
          title={t('Edit EMR Items')}
          HeaderIcon={MdEditSquare}
          onClose={() => {
            setOpenEditEmrItemsModal(false)
            setSelectedEditEmrItemsData(null)
          }}
          className='w-full lg:w-[95%] relative'
        >
          <EditEmrItemsModal
            emrData={selectedEditEmrItemsData}
            visitData={visitData}
            selectedPatientData={visitData?.patient}
            onClose={() => {
              setOpenEditEmrItemsModal(false)
              setSelectedEditEmrItemsData(null)
            }}
            onUpdated={async items => {
              setSelectedEditEmrItemsData(prev =>
                prev ? { ...prev, items } : prev
              )
              await refreshVisitData()
            }}
          />
        </ReusableModal>
      )}
      <ReusableModal
        position='top'
        isVisible={Boolean(clinicalOrderReportType)}
        title={
          clinicalOrderReportType === 'imaging'
            ? t('Radiology / Imaging Order')
            : t('Laboratory Order')
        }
        HeaderIcon={clinicalOrderReportType === 'imaging' ? FaXRay : FaFlask}
        onClose={() => {
          setClinicalOrderReportType(null)
          setSelectedEmrData(null)
        }}
        className='w-full lg:w-[1000px] relative'
      >
        <ClinicalOrderReport
          emrData={selectedEmrData}
          reportType={clinicalOrderReportType}
        />
      </ReusableModal>

      <ReusableModal
        position='top'
        isVisible={viewVisitTrack}
        title={t('Visit Tracking')}
        HeaderIcon={FaRoute}
        onClose={() => {
          setViewVisitTrack(false)
          setTrackId(null)
        }}
        className='w-full lg:w-[95%] relative'
      >
        <TrackingContent trackType={'visit'} trackId={trackId} t={t} />
      </ReusableModal>

      <PatientJourneyModal
        visible={viewJourney}
        onClose={() => setViewJourney(false)}
        patientId={visitData?.patient?.patient_id}
        fileNumber={visitData?.patient?.file_no || visitData?.patient?.file_number}
        documentId={visitData?.patient?.document_id}
        visitId={visitData?.visit_id}
      />

      <ConfirmationModal
        visible={openDeleteVisitModal}
        setVisible={setOpenDeleteVisitModal}
        header={t('Delete Patient Visit')}
        message={t(
          'Are you sure you want to delete this patient visit? This operation is irreversible and will delete the visit, EMRs, invoices, and items.'
        )}
        Icon={FaTrashAlt}
        acceptLabel={t('Delete')}
        rejectLabel={t('Cancel')}
        isLoading={isDeleting}
        onAccept={async () => {
          setIsDeleting(true)
          try {
            const res = await dispatch(
              deleteVisitHistory({ visit_id: visitData?.visit_id })
            ).unwrap()
            if (res) {
              const payload = {
                ...getVisitDataPayload,
                start_date: moment(getVisitDataPayload?.start_date).format(
                  'YYYY-MM-DD'
                ),
                end_date: moment(getVisitDataPayload?.start_date).format(
                  'YYYY-MM-DD'
                )
              }
              dispatch(getVisitsList(payload))
              setOpenDeleteVisitModal(false)
            }
          } catch (err) {
            console.error('Deletion failed:', err)
          } finally {
            setIsDeleting(false)
          }
        }}
      />
    </div>
  )
}

export const CancelVisitForm = ({
  getVisitDataPayload,
  setOpenCancelVisitModal,
  visitData
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const initialValues = {
    reason: ''
  }
  const validationSchema = Yup.object().shape({
    reason: Yup.string().trim().required(t('Reason is required'))
  })

  const handleSubmit = async values => {
    let payload = {
      reason: values?.reason,
      visit_id: visitData?.visit_id
    }
    setIsLoading(true)
    await dispatch(cancelVisit(payload)).then(res => {
      if (res?.payload?.message) {
        setOpenCancelVisitModal(false)
        let getPayload = {
          ...getVisitDataPayload,
          start_date: moment(getVisitDataPayload?.start_date).format(
            'YYYY-MM-DD'
          ),
          end_date: moment(getVisitDataPayload?.start_date).format('YYYY-MM-DD')
        }
        dispatch(getVisitsList(getPayload))
      }
    })
    setIsLoading(false)
  }
  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, handleChange, values }) => (
          <Form>
            <div className={`flex flex-col gap-1 w-full mb-3 `}>
              <label className='input-label'>{t('Addreason')}</label>
              <textarea
                placeholder={t('Enterreason')}
                className='bg-gray-100 border border-gray-300 p-2 rounded-lg text-[14px] w-full !outline-none !shadow-none hover:border-primary'
                name='reason'
                value={values.reason}
                rows={3}
                onChange={handleChange}
              />
              {errors.reason && touched.reason && (
                <span className='text-red-500 text-sm'>{errors.reason}</span>
              )}
            </div>
            <div className='flex justify-end items-center'>
              <CustomButton
                loading={isLoading}
                type='submit'
                icon={<FaCheckDouble size={12} className='me-2' />}
                label={t('CancelVisit')}
                buttonType='primary'
                className='!uppercase'
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default VisitDetail
